import * as Sentry from "@sentry/vue";
import { signInWithCustomToken } from "firebase/auth";
import { firebaseAuth } from "@/helpers/firebase/firebase";
import { sendMessageToFlutter } from "../bridge";
import { FlutterChannel } from "../enums/channel";
import { useAuthStore } from "@/stores/modules/auth/auth";

/**
 * Logs out the Flutter authentication instance
 */
export function logoutFlutterAuthInstance(): void {
  sendMessageToFlutter(FlutterChannel.LOGOUT_AUTH);
}

/**
 * Requests a Google ID token from Flutter
 */
export function askGoogleIdTokenFlutter(): void {
  const authStore = useAuthStore();
  sendMessageToFlutter(FlutterChannel.GOOGLE_ID, undefined, () => {
    authStore.cancelAuth();
  });
}

/**
 * Requests an Apple ID token from Flutter
 */
export function askAppleIdTokenFlutter(): void {
  const authStore = useAuthStore();
  sendMessageToFlutter(FlutterChannel.APPLE_ID, undefined, () => {
    authStore.cancelAuth();
  });
}

/**
 * Cancels Apple authentication and logs the cancellation message
 */
export function cancelAppleAuth(message: string): void {
  Sentry.captureMessage(message);
  const authStore = useAuthStore();
  authStore.cancelAuth();
}

/**
 * Cancels Google authentication and logs the cancellation message
 */
export function cancelGoogleAuth(message: string): void {
  Sentry.captureMessage(message);
  const authStore = useAuthStore();
  authStore.cancelAuth();
}

/**
 * Signs in with a custom authentication token and reloads the page
 */
export function signInWithCustomAuthToken(idToken: string): void {
  signInWithCustomToken(firebaseAuth, idToken)
    .then(() => {
      window.location.reload();
    })
    .catch((e) => {
      Sentry.captureException(e);
      window.location.reload();
    });
}
